"use strict";
/**
 * Throws an invalid type error
 * @param {string} message The message to show when the error is thrown
 * @returns {void}
 */

module.exports = function InvalidTypeError(message) {
  Error.captureStackTrace(this, this.constructor);
  this.name = this.constructor.name;
  this.message = message;
};
require("util").inherits(module.exports, Error);
//# sourceMappingURL=invalidType.js.map
//# sourceMappingURL=invalidType.js.map



//////////////////
// WEBPACK FOOTER
// ./node_modules/yoastseo/js/errors/invalidType.js
// module id = 175
// module chunks = 0